import { createRouter, createWebHistory } from 'vue-router'
import HelloWorld from '@/components/HelloWorld.vue'
import LoguinPrincipal from '@/components/LoguinPrincipal.vue'

const routes = [
  {
    path: '/hello',
    name: 'HelloWorld',
    component: HelloWorld,
    props: { msg: 'Bem vindo ao sistema!' }
  },
  {
    path: '/loguinPrincipal',
    name: 'LoguinPrincipal',
    component: LoguinPrincipal,
    props: { msg: 'Bem vindo ao sistema!' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router